import {
	setUser, 
	setAuthentication, 
	setAppointments,
	setBookingPageURL
} from './actionCreators';

export function setUserAction(status) {
	return dispatch => dispatch(setUser(status));
}

export function setAuthenticationAction(status) {
	return dispatch => dispatch(setAuthentication(status));
}

export function setAppointmentsAction(status) {
	return dispatch => dispatch(setAppointments(status));
}

export function setBookingPageURLAction(status) {
	return dispatch => dispatch(setBookingPageURL(status));
}